import { css } from '@emotion/css';
import { m, mobileMediaQuery } from '@snapchat/snap-design-system-marketing';

export const customLocaleDropdownButtonCss = css`
  align-items: center;
  background-color: white;
  border-radius: 25px;
  border: 2px solid ${m('--fg-color')};
  color: ${m('--fg-color')};
  cursor: pointer;
  display: flex;
  /* Set font-family here or the var from the default motif is used */
  font-family: ${m('--font-family')};
  font-size: 14px;
  font-weight: 500;
  height: 42px;
  justify-content: space-between;
  min-width: 160px;
  padding: ${m('--spacing-s')} ${m('--spacing-m')};

  ${mobileMediaQuery} {
    width: 100%;
  }
`;

export const dropdownButtonIconCss = css`
  margin-left: ${m('--spacing-s')};
  transition: transform 250ms;
  transform: rotate(0deg); /* 'up' */
  fill: ${m('--fg-color')};
`;

export const dropdownButtonIconDownCss = css`
  transform: rotate(180deg); /* 'down' */
`;
